import React, { useEffect, useState } from "react";
import "./Section2.css";
import Icons from "../../../../../Config/Images";

// const partners = [
//   Icons.partner1_image,
//   Icons.partner1_image,
//   Icons.partner1_image,
//   Icons.partner1_image,
// ];

const Section2 = ({ partnersData }) => {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    if (partnersData?.length > 0) {
      setPartners(partnersData);
    }
  }, [partnersData]);

  return (
    <>
      <div className="section-2">
        <p className="section-2-header">Our Partners</p>
        <div className="partners-div">
          {partners?.map((partner, index) => (
            <div className="partner-img" key={index}>
              <img
                src={partner?.partner_image_id}
                alt={`Partner ${index + 1}`}
              />
            </div>
          ))}
        </div>
      </div>

      <div className="section-22">
        <p className="section-2-header">Our Logistics Partner</p>
        <div className="partners-div">
          <img
            className="sequel-img"
            src={Icons.sequel_img}
            // alt={`Partner ${index + 1}`}
          />
        </div>
      </div>
    </>
  );
};

export default Section2;
